export default "__VITE_ASSET__fc9e1890__"